const $ = require('jquery');
const Swal = require('sweetalert2');
require('jquery-circle-progress');
const glossaryHelper = require('./helper/glossary');
let glossary;

// Backstretch
const backstretch = require('jquery-backstretch');
const polyfillObserver = require('intersection-observer');
const lozad = require('lozad');

// Variables globales pour les observers lozad (eviter accumulation)
let wysimagesObs, twoImgObs, threeImgObs;

$(document).ready(function () {
    if ($('#glossary').length > 0) {
        glossary = new glossaryHelper(document.getElementById("glossary"));
        glossary.setupAllListeners();

        $('#main-content').on('chapter-updated', function (e, chapter) {
            $('ol#glossary-list a.active').removeClass("active");
            $('ol#glossary-list a[data-chapter="' + chapter["slug"] + '"]').addClass("active");

            requestAnimationFrame(function () {
                scrollToPost();
                launchBackstretch();
                launchFancybox();
            });
        });
    }

    // Sommaire "voir +" toggle
    $(document).on('click', '[data-sommaire-expand]', function (e) {
        e.preventDefault();
        var $sommaire = $('#glossary-list');
        $sommaire.removeAttr('data-sommaire-collapsed');
        $(this).parent('.sommaire-toggle').hide();
    });

    if ($('#quizz-form').length > 0) {
        handleQuizz();
    }
});


function scrollToPost() {
    // Scroll to chapter title
    const _titlePosition = parseInt($('h1').offset().top - 110);
    $('html, body').stop(true, true).animate({scrollTop: _titlePosition}, 500, function () {
    });
}

let xhrQuizz;

function handleQuizz() {
    $('#quizz-form').on('submit', function (e) {
        e.preventDefault();
        let quizz = $('#quizz-form');
        let canSubmit = true;

        if (xhrQuizz != undefined) {
            xhrQuizz.abort();
        }

        // Check if each question has an anwser
        quizz.find('.question-wrapper').each(function(i,el){
            let question = $(el);
            let isAnwsered = false

            // Each answer
            question.find('input').each(function(i,el){
                if($(el).is(':checked')) {
                    isAnwsered = true
                    return
                }
            })

            // If none of checkbox is checked, can't submit the form
            if(!isAnwsered) {
                canSubmit = false;
                question.addClass('error')

                salert('Erreur !', 'Vous devez répondre à toutes les questions avant de valider vos réponses.', 'error')
            } else {
                question.removeClass('error')
            }
        });

        // Quizz submission
        if(canSubmit) {

            // Loading submit
            quizz.find('[type="submit"]').addClass('cc-loading');

            // XHR
            xhrQuizz = $.post($(this).attr('data-action'), $(this).serialize(), function (data) {

                // SUCCESS
                // show results section
                $('.wrap-form-results').show();

                // Scroll to result section
                let _resultPosition = parseInt($('.wrap-form-results').offset().top - 110);
                $('html, body').stop(true, true).animate({scrollTop: _resultPosition}, 500, function () {
                });

                // Animate circular
                let quizzScore = data.my_answer.label
                
                if($('.circle').length)
                    animateCircle(data.my_answer.score, quizzScore);

                // display result text
                $('[data-js-response]').html(data.my_answer.content);


                // Statistics for each question
                Object.keys(data.results.details).map(function(objectKey, index) {
                    
                    let question = $('[data-id="'+objectKey+'"]');

                    // If question exists
                    if(question.length > 0) {

                        var answers = data.results.details[objectKey];

                        // Display each answer %
                        Object.keys(answers).map(function(objKey, idx) {
                            var result = answers[objKey];
                            let answer = $('[data-id-answer="'+objKey+'"]');

                            if(answer.length) {
                                let percentage = (result * 100 / data.results.total).toFixed(0);
                                answer.find('.percent-result strong').text(percentage+'%')
                            }
                        });
                    }
                });
                // Show each percent statistics after each answer
                $('.percent-result').show()



                // Statistics for each question
                Object.keys(data.results.good_answers).map(function(objectKey, index) {
                    
                    let question = $('[data-id="'+objectKey+'"]');

                    // If question exists
                    if(question.length > 0) {

                        var good_answers = data.results.good_answers[objectKey];

                        // Display each answer %
                        Object.keys(good_answers).map(function(objKey, idx) {
                            var result = good_answers[objKey];
                            let answer = $('[data-id-answer="'+result+'"]');

                            console.log(answer)

                            if(answer.length) {
                                answer.addClass('good-answer')
                            }
                        });
                    }
                });
                

                


            }).fail(function(data) {
                // show error modal
                salert('Erreur', data.responseJSON, 'error')

                // Hide results section
                $('.wrap-form-results').hide();

            }).always(function(data) {
                quizz.find('[type="submit"]').removeClass('cc-loading');
            });
        }
    });
}


function launchBackstretch() {
    // Deconnecter les observers de app.js au premier changement de chapitre
    if (window._appObservers) {
        window._appObservers.forEach(function (obs) {
            obs.observer.disconnect();
        });
        window._appObservers = null;
    }

    // Deconnecter les anciens observers pour eviter l'accumulation
    if (wysimagesObs) wysimagesObs.observer.disconnect();
    if (twoImgObs) twoImgObs.observer.disconnect();
    if (threeImgObs) threeImgObs.observer.disconnect();

    wysimagesObs = lozad('.wysimages figure', {
        rootMargin: '50px 0px',
        loaded: function(el) {}
    });
    wysimagesObs.observe();
    twoImgObs = lozad('.wysi-two-img img', {
        rootMargin: '50px 0px'
    });
    twoImgObs.observe();
    threeImgObs = lozad('.wysi-three-img img', {
        rootMargin: '50px 0px'
    });
    threeImgObs.observe();
}

function launchFancybox() {
    var $images = $('[data-field="content"] .wysi-two-img img, [data-field="content"] .wysi-three-img img');
    $images = $images.filter(function () {
        return !$(this).parent('a[data-fancybox]').length;
    });
    if (!$images.length) return;

    $images.each(function () {
        var img = this;
        var src = img.getAttribute('src') || img.getAttribute('data-src') || '';
        var alt = img.getAttribute('alt') || '';
        var a = document.createElement('a');
        a.href = src;
        a.setAttribute('data-fancybox', 'gallery');
        a.setAttribute('data-caption', alt);
        img.parentNode.insertBefore(a, img);
        a.appendChild(img);
    });
}

function salert(title, text,icon) {
    Swal.fire({
        title: title,
        text: text,
        icon: icon,
        confirmButtonText: 'Fermer'
    })
}

function animateCircle(score, success) {
    if(success == 'bad') {
        var fillColor = {gradient: ["#b7453b", "#922016"]}
        var strongColor = 'cc-red'
    } else if(success == 'good') {
        var fillColor = {gradient: ["#168385", "#0c5a5c"]}
        var strongColor = 'cc-green'
    } else {
        var fillColor = {gradient: ["#4b7b9d", "#164d74"]}
        var strongColor = 'cc-blue'
    }

    var circle = $('.circle').circleProgress({
        size: 200,
        startAngle: -Math.PI / 2,
        thickness: 20,
        value: (score / 100),
        fill: fillColor
    }).on('circle-animation-progress', function (event, progress, stepValue) {

        $(this).find('strong span').removeClass().addClass(strongColor).html(Math.round(stepValue * 100));
        $(this).find('strong em').removeClass().addClass(strongColor)
    });
}